import { createContext } from 'use-context-selector'
import PropTypes from 'prop-types'
import combinedReducers from './reducers'

export const StateContext = createContext()
export const UpdaterContext = createContext()

const InventoryStoreProvider = ({ children, initialValue = {} }) => {
  const { store, reducers } = combinedReducers(initialValue)

  return (
    <StateContext.Provider value={{ store }}>
      <UpdaterContext.Provider value={{ reducers }}>
        {children}
      </UpdaterContext.Provider>
    </StateContext.Provider>
  )
}

InventoryStoreProvider.propTypes = {
  children: PropTypes.node.isRequired,
  initialValue: PropTypes.object,
}

export default InventoryStoreProvider
